var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Output, Input, EventEmitter } from '@angular/core';
var FontColorPickerComponent = /** @class */ (function () {
    function FontColorPickerComponent() {
        // 选择颜色以后调用父组件中的方法，将数据传递出去，方法
        this.sentColor = new EventEmitter();
    }
    // 当选择颜色以后
    FontColorPickerComponent.prototype.colorPickerChangeFun = function () {
        this.sentColor.emit(this.color);
    };
    __decorate([
        Input()
    ], FontColorPickerComponent.prototype, "color", void 0);
    __decorate([
        Output()
    ], FontColorPickerComponent.prototype, "sentColor", void 0);
    FontColorPickerComponent = __decorate([
        Component({
            selector: 'font-color-picker',
            styles: [".color-picker-content{ width: 100%; height: 100%; position: relative; } .transparent{ position: absolute; background: url(\"/assets/common/images/colorPicker/transparent.png\") 0 0 no-repeat; background-size: 100% 100%; z-index: 1; bottom: 0; right: 3px; width: 13px; height: 2px; } .color-picker{ border: 0; width: 100%; height: 100%; background: transparent; cursor: pointer; } .color-picker:focus{ outline: none;    border-color: transparent;   box-shadow:none; } .font-color{ width: 13px; height: 2px; border: none; z-index: 2; position: absolute; bottom: 0; right: 3px; }"],
            template: "<div class=\"color-picker-content\"> <input  class=\"color-picker\" type=\"button\" [(colorPicker)]=\"color\"  (colorPickerChange)=\"colorPickerChangeFun()\" [cpAlphaChannel]=\"'always'\" [cpOutputFormat]=\"'rgba'\" [cpPresetColors]=\"['#e33c39', '#e96033', '#ed913a', '#f0af41', '#f6db4d', '#acd646' , '#70c040' , '#55bfc0' , '#3d90f7', '#3358e2', '#6938c9', '#da4494', '#000000', '#bfbfbf' , '#e8e8e8' , '#ffffff']\" /> <div class=\"transparent\"></div> <div class=\"font-color\" [style.background]=\"color\"></div> </div> "
        })
    ], FontColorPickerComponent);
    return FontColorPickerComponent;
}());
export { FontColorPickerComponent };
